import { ComplainType } from "./complainType";

export interface IComplainType {
	text: string;
	value: ComplainType;
}

const values: IComplainType[] = [
	{
		text: "Nicht definiert",
		value: ComplainType.None,
	},
	{
		text: "Schnittqualität nicht zufriedenstellend",
		value: ComplainType.CutqualityLow,
	},
	{
		text: "Oberfläche übermässig zerkratzt",
		value: ComplainType.Scratches,
	},
	{
		text: "Fehlende Ausschnitte",
		value: ComplainType.MissingCuts,
	},
	{
		text: "Fehlerhafte Abkantung",
		value: ComplainType.WrongBending,
	},
	{
		text: "Masse ausserhalb der Toleranz",
		value: ComplainType.OutOfTolerance,
	},
	{
		text: "Transportschaden",
		value: ComplainType.TransportDamage,
	},
	{
		text: "Teile fehlen in Lieferung",
		value: ComplainType.Missing,
	},
	{
		text: "Andere Beanstandung",
		value: ComplainType.Other,
	},
	{
		text: "Falsche Schliffrichtung",
		value: ComplainType.WrongGrainDirection,
	},
	{
		text: "Fehlende, falsche oder mangelhafte Pulverbeschichtung",
		value: ComplainType.PowderCoating,
	},
	{
		text: "Fehlende, falsche oder mangelhafte Schweissnaht",
		value: ComplainType.Weldline,
	},
	{
		text: "Gewinde, Senkung oder Durchzug fehlt oder ist mangelhaft",
		value: ComplainType.Features,
	},
	{
		text: "Fehlende, falsche oder mangelhafte Verzinkung",
		value: ComplainType.ZincCoating,
	},
	{
		text: "Einpressung fehlt oder entspricht nicht der Bestellung",
		value: ComplainType.WrongOrMissingPressJoin,
	},
];

export default values;
